var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(("max-width: " + _vm.maxWidth))},[_c('div',{class:_vm.$style.responsive,style:(("padding-top: " + ((1 / _vm.aspectRatio) * 100) + "%;"))},[_c('div',{class:_vm.$style.responsiveContent},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }